import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ImportAbiMutationVariables = Types.Exact<{
  input: Types.ImportAbiInput;
}>;

export type ImportAbiMutation = {
  __typename?: 'Mutation';
  importAbi: {
    __typename?: 'ImportAbiPayload';
    abi: {
      __typename?: 'ContractAbi';
      id: any;
      name?: string | null;
      contentHash: string;
      createdAt: any;
    };
  };
};

export const ImportAbiDocument = gql`
  mutation ImportAbi($input: ImportAbiInput!) {
    importAbi(input: $input) {
      abi {
        id
        name
        contentHash
        createdAt
      }
    }
  }
`;
export type ImportAbiMutationFn = Apollo.MutationFunction<
  ImportAbiMutation,
  ImportAbiMutationVariables
>;

/**
 * __useImportAbiMutation__
 *
 * To run a mutation, you first call `useImportAbiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAbiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAbiMutation, { data, loading, error }] = useImportAbiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportAbiMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportAbiMutation,
    ImportAbiMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportAbiMutation, ImportAbiMutationVariables>(
    ImportAbiDocument,
    options,
  );
}
export type ImportAbiMutationHookResult = ReturnType<
  typeof useImportAbiMutation
>;
export type ImportAbiMutationResult = Apollo.MutationResult<ImportAbiMutation>;
export type ImportAbiMutationOptions = Apollo.BaseMutationOptions<
  ImportAbiMutation,
  ImportAbiMutationVariables
>;
